import React from 'react';
import logoFooter from '../../assets/images/logos/logo-digitalfactura-footer.png';
import { useModal } from '../../context/ModalContext';
import './Footer.css';

const Footer = () => {
  const { openModal } = useModal();
  const currentYear = new Date().getFullYear();

  const handleScrollTo = (e, targetId) => {
    e.preventDefault();
    const targetEl = document.querySelector(targetId);
    if (targetEl) {
      const headerOffset = 70;
      const elementPosition = targetEl.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="df-footer" role="contentinfo">
      <div className="df-footer-container">
        {/* Fila Superior: 4 Columnas Oficiales */}
        <div className="df-footer-top">
          {/* Columna 1: Marca y Resumen */}
          <div className="df-footer-brand-col">
            <img
              src={logoFooter}
              alt="Digital Factura"
              className="df-footer-logo"
            />
            <p className="df-footer-desc">
              Proveedor Autorizado de Certificación No. 58354. Facturación electrónica, software administrativo y desarrollo a la medida.
            </p>
          </div>

          {/* Columna 2: Soluciones */}
          <div className="df-footer-nav-col">
            <span className="df-footer-nav-title">Soluciones</span>
            <a
              href="#timbrado"
              className="df-footer-link"
              onClick={(e) => handleScrollTo(e, '#timbrado')}
            >
              Timbrado corporativo
            </a>
            <a
              href="#sicai"
              className="df-footer-link"
              onClick={(e) => handleScrollTo(e, '#sicai')}
            >
              SICAI Web · Pro · Server
            </a>
            <a
              href="#deconect"
              className="df-footer-link"
              onClick={(e) => handleScrollTo(e, '#deconect')}
            >
              DeConect
            </a>
            <a
              href="#addendas"
              className="df-footer-link"
              onClick={(e) => handleScrollTo(e, '#addendas')}
            >
              Addendas
            </a>
          </div>

          {/* Columna 3: Contacto y Soporte */}
          <div className="df-footer-nav-col">
            <span className="df-footer-nav-title">Contacto y soporte</span>
            <a href="tel:3336337809" className="df-footer-link">
              33.3633.7809
            </a>
            <a href="tel:3336367965" className="df-footer-link">
              33.3636.7965
            </a>
            <a href="tel:3336368722" className="df-footer-link">
              33.3636.8722
            </a>
            <a href="mailto:soporte@decaber.com" className="df-footer-link">
              soporte@decaber.com
            </a>
          </div>

          {/* Columna 4: Acciones Oficiales + Denuncias */}
          <div className="df-footer-actions-col">
            <a
              href="https://facturacion.digitalfactura.mx/#/login"
              target="_blank"
              rel="noopener noreferrer"
              className="df-footer-btn-app"
            >
              Aplicación Gratuita
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M5 12h14M13 6l6 6-6 6" />
              </svg>
            </a>

            <button
              type="button"
              className="df-footer-text-btn"
              onClick={() => openModal('sla')}
            >
              Niveles de servicio
            </button>

            {/* Conservando canal de denuncias */}
            <button
              type="button"
              className="df-footer-text-btn"
              onClick={() => openModal('denuncia')}
            >
              Canal de denuncias
            </button>

            <a
              href="https://www.digitalfactura.com/Portal_Firma_Manifiesto"
              target="_blank"
              rel="noopener noreferrer"
              className="df-footer-text-btn"
            >
              Firmar Manifiesto
            </a>

            <a
              href="https://1735765.fs1.hubspotusercontent-na1.net/hubfs/1735765/Digital-Factura_00001000000718099104.zip"
              target="_blank"
              rel="noopener noreferrer"
              className="df-footer-text-btn"
            >
              Certificado PAC Digital Factura
            </a>

            {/* Recuperación de contraseñas de instalación */}
            <button
              type="button"
              className="df-footer-text-btn"
              onClick={() => openModal('recuperarSicai')}
            >
              Recuperar SICAI
            </button>

            <button
              type="button"
              className="df-footer-text-btn"
              onClick={() => openModal('recuperarDeConnect')}
            >
              Recuperar DeConnect
            </button>
          </div>
        </div>

        {/* Fila Inferior: Derechos y Legales Oficiales */}
        <div className="df-footer-bottom">
          <span>© {currentYear} Digital Factura</span>

          <nav className="df-footer-legal-nav" aria-label="Enlaces legales y regulatorios">
            <button
              type="button"
              className="df-footer-legal-link"
              onClick={() => openModal('privacy')}
            >
              Aviso de privacidad
            </button>
            <span className="df-footer-legal-dot">·</span>

            <button
              type="button"
              className="df-footer-legal-link"
              onClick={() => openModal('terms')}
            >
              Términos y condiciones
            </button>
            <span className="df-footer-legal-dot">·</span>

            <button
              type="button"
              className="df-footer-legal-link"
              onClick={() => openModal('contract')}
            >
              Contrato de prestación de servicios
            </button>
            <span className="df-footer-legal-dot">·</span>

            <button
              type="button"
              className="df-footer-legal-link"
              onClick={() => openModal('arco')}
            >
              Derechos ARCO
            </button>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
